import React from "react";
import { Route, Redirect } from "react-router";
import { NestedRoute } from "@irati/utils/history/routing";
import AppContainer from "@irati/ui/src/AppContainer";
import Logout from "../../containers/Logout";
import Login from "../../containers/Login/Login";
import ForgotPassword from "../../containers/ForgotPassword/ForgotPassword";
import ResetPassword from "../../containers/ResetPassword/ResetPassword";
import CheckEmail from "../../components/CheckEmail";
import SelfSignUp from "../../components/SelfSignUp/SelfSignUp";
import LoginSamlIDP from "../../containers/Login/LoginSamlIDP";
var Welcome = function (_a) {
    var match = _a.match, location = _a.location;
    if (location.pathname === "/welcome/logout") {
        // <AppContainer /> wrapper is making infinite loops for logout route
        return React.createElement(Route, { exact: true, path: "/welcome/logout", component: Logout });
    }
    return (React.createElement(AppContainer, null,
        React.createElement(Route, { exact: true, path: "/welcome", render: function () { return React.createElement(Redirect, { to: "/welcome/login" }); } }),
        React.createElement(NestedRoute, { unauthed: true, exact: true, match: match.url, path: "/login", title: "Login", component: Login }),
        React.createElement(NestedRoute, { unauthed: true, exact: true, match: match.url, path: "/login/idp", title: "Login", component: LoginSamlIDP }),
        React.createElement(NestedRoute, { unauthed: true, match: match.url, path: "/login/check-email", title: "Check Email", component: CheckEmail }),
        React.createElement(NestedRoute, { unauthed: true, match: match.url, path: "/login/forgotten-password", title: "Forgot Password", component: ForgotPassword }),
        React.createElement(NestedRoute, { unauthed: true, match: match.url, path: "/login/reset-password", title: "Reset Password", component: ResetPassword }),
        React.createElement(NestedRoute, { unauthed: true, match: match.url, path: "/signup", component: SelfSignUp })));
};
export default Welcome;
